import * as React from 'react';

import { POOL_TYPE } from 'defs/pools';
import i18n from 'helper/i18n';

import { ImageProps } from 'components/atoms/Image/Image';
import PoolTeaser from 'components/organisms/Pool/elements/PoolTeaser';
import { ContentTypePoolRecipeDtoType } from 'types/services/magnolia/dtos/ContentTypePoolRecipeDto';
import { RenderPoolItemsAdditionalProps } from './index';
import { getItemURL } from './utils';

type RecipePropsType = {
	type: 'recipe';
	items: ContentTypePoolRecipeDtoType[];
	custom: RenderPoolItemsAdditionalProps;
};

export const Recipe = ({ type, items }: RecipePropsType) => {
	return (
		<div className="container">
			<div className="row">
				<div className="col-xs-12">
					<div className="o-pool__teasers">
						{items.map((item: ContentTypePoolRecipeDtoType) => {
							const menuTypes = item.tags['menu-type'];
							const recipeTag = (menuTypes[0] || {}).name;
							const recipeInfos = [
								{
									value: item.calories,
									unit: i18n('react.impulsCoach.views.pools.units.calories'),
								},
								{
									value: item.totalDurationFormatted,
								},
							];
							if (item.nutrition) {
								recipeInfos.push({
									value: i18n(`react.impulsCoach.components.poolTeaser.${item.nutrition}`),
								});
							}
							return (
								<PoolTeaser
									key={item.externalId}
									tag={
										recipeTag ||
										i18n(`react.impulsCoach.components.poolTeaser.recipe.tag.${'UNDEFINED'}`)
									}
									modifier={type}
									headline={item.title}
									image={
										(item.previewImage as ImageProps) ||
										(item.fallbackImage as ImageProps) ||
										({} as ImageProps)
									}
									link={getItemURL(item.externalId, POOL_TYPE.RECIPE)}
									infos={recipeInfos}
								/>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};
